export const TITLE_NAME_K002 = 'レート別';
export const TITLE_NAME_K003 = '地区別';
export const TITLE_NAME_K004 = '損益分岐割数別';
export const TITLE_NAME_K005 = 'ランク別';
export const TITLE_NAME_K006 = '設置台数別';
export const TITLE_NAME_K007 = 'ランキング';
export const TITLE_NAME_K008 = '地区別（機種）';
export const TITLE_NAME_K009 = '損益分岐割数別（機種）';
export const TITLE_NAME_K010 = 'ランク別（機種）';
export const TITLE_NAME_K011 = '期間別';
export const TITLE_NAME_K012 = '導入後推移';
export const TITLE_NAME_K013 = '設定別';
export const TITLE_NAME_K014 = 'レート別比較';
export const TITLE_NAME_K015 = 'シン機種ページ';
